<template>
  <div>
    <h1>無料版お申し込みページ</h1>
    <div class="honnbunn">
      <p>{{ serviceTitle }}</p>
      <br />
    </div>
    <div class="guide hosoku input-caption">
      <div v-if="serviceExplanation" v-html="serviceExplanation"></div>
    </div>
    <p></p>
    <!--無料版お申し込みページの入力欄-->
    <div class="koumoku">
      <div
        v-for="([serviceSettingItemsKey, item], index) in Object.entries(
          serviceSettingItems,
        )"
        :key="index"
      >
        <div
          v-if="
            item.displayFlag === true &&
            item.cmsOnlyFlag === false &&
            item.deleteFlag !== true
          "
        >
          <div
            v-if="item.inputType === 'view'"
            :class="{ 'view-item': index !== 0 }"
          >
            <span
              >{{ item.label }}：{{ formData[serviceSettingItemsKey] }} <br
            /></span>
          </div>

          <div v-if="index === 0" class="hosoku">
            <p class="hissu">
              <img
                src="../../../../assets/required-mark.svg"
                class="required-mark"
              />
            </p>
            は入力必須<br /><br />
          </div>

          <span v-if="item.inputType !== 'view'">
            {{ item.label || item.title }}
            <p v-if="item.required === true" class="hissu">
              <img
                src="../../../../assets/required-mark.svg"
                class="required-mark"
              />
            </p>
            <br />
            <input
              v-if="item.inputType === 'text'"
              v-model="formData[serviceSettingItemsKey]"
              type="text"
              class="InputBox"
              :maxlength="item.maxLength"
              :class="{ error: errors[serviceSettingItemsKey] }"
            />
            <button
              v-if="serviceSettingItemsKey === 'companyAddressPostalCode'"
              class="kensaku"
              @click="fetchAddress"
            >
              検索
            </button>

            <textarea
              v-if="item.inputType === 'textarea'"
              v-model="formData[serviceSettingItemsKey]"
              type="text"
              class="TextAreaBox"
              :class="{ error: errors[serviceSettingItemsKey] }"
            ></textarea>

            <select
              v-if="serviceSettingItemsKey === 'companyAddress1'"
              v-model="formData[serviceSettingItemsKey]"
              class="dropdown"
              :class="{ error: errors[serviceSettingItemsKey] }"
            >
              <option v-if="hasMultiAddress" value="" selected>
                選択してください
              </option>
              <option
                v-for="address in allAddresses"
                :key="address"
                :value="address"
              >
                {{ address }}
              </option>
            </select>

            <select
              v-if="
                item.itemType === 'commonItems' &&
                item.inputType === 'select' &&
                serviceSettingItemsKey !== 'companyAddress1'
              "
              v-model="settingData.selectedKeys[serviceSettingItemsKey]"
              class="dropdown"
              :class="{ error: errors[serviceSettingItemsKey] }"
              @change="updateSelectJson(serviceSettingItemsKey)"
            >
              <option
                v-for="option in settingData.options[serviceSettingItemsKey]"
                :key="option.key"
                :value="option.key"
              >
                {{ option.label }}
              </option>
            </select>

            <select
              v-if="
                item.itemType === 'independentItems' &&
                item.inputType === 'select'
              "
              v-model="formData[serviceSettingItemsKey]"
              class="dropdown"
              :class="{ error: errors[serviceSettingItemsKey] }"
            >
              <option
                v-for="(label, value) in parseValues(item.setting)"
                :key="value"
                :value="JSON.stringify({ [value]: label })"
              >
                {{ label }}
              </option>
            </select>

            <div
              v-if="
                item.itemType === 'commonItems' &&
                item.inputType === 'radiobutton'
              "
              class="radioGroup"
              :class="{ error: errors[serviceSettingItemsKey] }"
            >
              <div
                v-for="(label, value) in settingData.options[
                  serviceSettingItemsKey
                ]"
                :key="value"
              >
                <input
                  v-model="settingData.selectedKeys[serviceSettingItemsKey]"
                  type="radio"
                  :value="value"
                  @change="updateRadioJson(serviceSettingItemsKey)"
                />
                {{ label }}
              </div>
            </div>

            <div
              v-if="item.inputType === 'file'"
              class="fileInput"
              :class="{ error: errors[serviceSettingItemsKey] }"
            >
              <label :for="`file-${serviceSettingItemsKey}`">選択</label>
              <span :id="`file-name-${serviceSettingItemsKey}`">{{
                getFileNameToDisplay(formData[serviceSettingItemsKey])
              }}</span>
              <input
                :id="`file-${serviceSettingItemsKey}`"
                type="file"
                style="display: none"
                :class="{ error: errors[serviceSettingItemsKey] }"
                @change="handleFileUpload($event, serviceSettingItemsKey)"
              />
            </div>

            <div
              v-if="
                item.itemType === 'independentItems' &&
                item.inputType === 'radiobutton'
              "
              class="radioGroup"
              :class="{ error: errors[serviceSettingItemsKey] }"
            >
              <div
                v-for="(label, value) in parseValues(item.setting)"
                :key="value"
                :value="JSON.stringify({ [value]: label })"
              >
                <input
                  v-model="formData[serviceSettingItemsKey]"
                  type="radio"
                  :value="JSON.stringify({ [value]: label })"
                />
                <span class="input-caption">{{ label }}</span>
              </div>
              <div v-if="JSON.parse(item.setting).otherFlg">
                <input
                  v-model="formData[serviceSettingItemsKey]"
                  type="radio"
                  :value="
                    JSON.stringify({
                      [JSON.parse(item.setting).other]: JSON.parse(item.setting)
                        .other,
                    })
                  "
                />
                <span class="input-caption">{{
                  JSON.parse(item.setting).other
                }}</span>
                <input
                  v-model="formData[serviceSettingItemsKey + 'OtherText']"
                  type="text"
                  :placeholder="JSON.parse(item.setting).other + 'の内容を入力'"
                  maxlength="100"
                  :disabled="
                    JSON.parse(formData[serviceSettingItemsKey] || '{}')[
                      JSON.parse(item.setting).other
                    ] !== JSON.parse(item.setting).other
                  "
                />
              </div>
            </div>

            <div
              v-if="
                item.itemType === 'independentItems' &&
                item.inputType === 'checkbox'
              "
              class="checkBoxGroup"
              :class="{ error: errors[serviceSettingItemsKey] }"
            >
              <div
                v-for="(label, value) in parseValues(item.setting)"
                :key="value"
                :value="JSON.stringify({ [value]: label })"
              >
                <input
                  v-model="formData[serviceSettingItemsKey + '_check_' + value]"
                  :type="item.inputType"
                  :value="JSON.stringify({ [value]: label })"
                  @change="createCheckboxData(serviceSettingItemsKey, item)"
                />
                <span class="input-caption">{{ label }}</span>
              </div>
              <div v-if="JSON.parse(item.setting).otherFlg">
                <input
                  v-model="
                    formData[
                      serviceSettingItemsKey +
                        '_check_' +
                        JSON.parse(item.setting).other
                    ]
                  "
                  :type="item.inputType"
                  :value="
                    JSON.stringify({
                      [JSON.parse(item.setting).other]: JSON.parse(item.setting)
                        .other,
                    })
                  "
                  @change="createCheckboxData(serviceSettingItemsKey, item)"
                />
                <span class="input-caption">{{
                  JSON.parse(item.setting).other
                }}</span>
                <input
                  v-model="formData[serviceSettingItemsKey + 'OtherText']"
                  type="text"
                  :placeholder="JSON.parse(item.setting).other + 'の内容を入力'"
                  maxlength="100"
                  :disabled="
                    JSON.parse(formData[serviceSettingItemsKey] || '{}')[
                      JSON.parse(item.setting).other
                    ] !== JSON.parse(item.setting).other
                  "
                />
              </div>
            </div>

            <div
              v-if="
                item.itemType === 'independentItems' &&
                item.inputType === 'agree'
              "
              class="agreement-container"
            >
              <label class="agreement-label">
                <input
                  v-model="formData[serviceSettingItemsKey]"
                  type="checkbox"
                  class="checkBox"
                  :class="{ error: errors[serviceSettingItemsKey] }"
                  :disabled="item.urlRequired && !item.allLinksClicked"
                />
                <span class="agreement-text">
                  <span
                    v-for="(link, linkIndex) in item.parsedLinks"
                    :key="linkIndex"
                    class="link-item input-caption"
                  >
                    <template v-if="link.type === 'link'">
                      <a
                        :href="link.url"
                        target="_blank"
                        @click="handleIndependentLinkClick(item, linkIndex)"
                      >
                        {{ link.text }}
                      </a>
                    </template>
                    <template v-else-if="link.type === 'text'">
                      {{ link.text }}
                    </template>
                  </span>
                </span>
              </label>
            </div>

            <div
              v-if="
                item.itemType === 'agreeItems' &&
                serviceSettingItemsKey === 'locationAgree'
              "
            >
              <input
                v-model="formData[serviceSettingItemsKey]"
                type="checkbox"
                class="checkbox"
                :class="{ error: errors[serviceSettingItemsKey] }"
                :disabled="!settingData[serviceSettingItemsKey]"
              />
              <span>
                <template v-if="termsAgreeUrl[serviceSettingItemsKey] !== ''">
                  <a
                    :href="termsAgreeUrl[serviceSettingItemsKey]"
                    target="_blank"
                    @click="handleLinkClick(serviceSettingItemsKey)"
                    >位置情報取得</a
                  >
                </template>
                <template v-else>位置情報取得</template>
                することに同意します。
              </span>
            </div>

            <div
              v-if="
                item.itemType === 'agreeItems' &&
                serviceSettingItemsKey === 'termsAgree'
              "
            >
              <input
                v-model="formData[serviceSettingItemsKey]"
                type="checkbox"
                class="checkBox"
                :class="{ error: errors[serviceSettingItemsKey] }"
                :disabled="!settingData[serviceSettingItemsKey]"
              />
              <span>
                <template v-if="termsAgreeUrl[serviceSettingItemsKey] !== ''">
                  <a
                    :href="termsAgreeUrl[serviceSettingItemsKey]"
                    target="_blank"
                    @click="handleLinkClick(serviceSettingItemsKey)"
                    >利用規約</a
                  >
                </template>
                <template v-else>利用規約</template>
                に同意します。
              </span>
            </div>

            <div
              v-if="
                item.itemType === 'agreeItems' &&
                serviceSettingItemsKey === 'privacyPolicyAgree'
              "
            >
              <input
                v-model="formData[serviceSettingItemsKey]"
                type="checkbox"
                class="checkBox"
                :class="{ error: errors[serviceSettingItemsKey] }"
                :disabled="!settingData[serviceSettingItemsKey]"
              />

              NTTドコモビジネスの
              <span>
                <template v-if="termsAgreeUrl[serviceSettingItemsKey] !== ''">
                  <a
                    :href="termsAgreeUrl[serviceSettingItemsKey]"
                    target="_blank"
                    @click="handleLinkClick(serviceSettingItemsKey)"
                    >プライバシーポリシー</a
                  >
                </template>
                <template v-else>プライバシーポリシー</template>
                に同意し、記入内容が正しいことについて確認しました。
              </span>
            </div>

            <br />
            <p v-if="errors[serviceSettingItemsKey]" class="error-message">
              {{ errors[serviceSettingItemsKey] }}
            </p>
            <p
              v-if="item.inputType !== 'agree' && item.note"
              class="hosoku input-caption"
              :class="getNoteClass(item, errors[serviceSettingItemsKey])"
            >
              <span
                v-for="(part, noteIndex) in parsedText(item.note)"
                :key="noteIndex"
              >
                <template v-if="part.type === 'link'">
                  <a :href="part.url" target="_blank">{{ part.text }}</a>
                </template>
                <template v-else>
                  {{ part.text }}
                </template>
              </span>
            </p>
            <p
              v-if="
                item.itemType === 'independentItems' &&
                item.inputType === 'agree' &&
                item.note
              "
              class="hosoku input-caption"
              :class="getNoteClass(item, errors[serviceSettingItemsKey])"
            >
              <span
                v-for="(notePart, noteIndex) in item.parsedNote"
                :key="noteIndex"
                class="note-item"
              >
                <template v-if="notePart.type === 'link'">
                  <a :href="notePart.url" target="_blank">{{
                    notePart.text
                  }}</a>
                </template>
                <template v-if="notePart.type === 'text'">
                  {{ notePart.text }}
                </template>
              </span>
            </p>
            <br />
          </span>
        </div>
      </div>

      <div class="koyuu">
        申し込み情報を送信する際に上記全ての規約への同意が必要です。<br />
        <br />
        <br />
        <!--[入力内容を確認][戻る]ボタン-->
        <div class="kakuninn">
          <!-- <GoBackButton @click="goBack" /> -->
          <ConfirmButton @click="confirmInput" />
        </div>
      </div>
      <br />
      <br />
    </div>
    <loading v-model:active="isLoading" :is-full-page="true" />
  </div>
</template>
<script>
import { mapState, mapMutations } from "vuex";
import axios from "axios";

// import GoBackButton from '@components/atoms/button/goBack/go-back-button.vue';
import ConfirmButton from "@components/atoms/button/confirm/confirm-button.vue";
import Loading from "vue-loading-overlay";

import {
  checkCommonItemValid,
  checkIndependentItemValid,
  checkValidAgree,
} from "@components/common/validation/input-validation.js";
import {
  COMMON_SETTING_MAP,
  COMMON_ITEM_LOADING_MAP,
} from "@components/common/constants.js";
import { cloneDeep } from "lodash";
import DOMPurify from "dompurify";
import { showInfoToast } from "@components/common/utils.js";
import { NETWORK_ERROR_MESSAGE } from "@components/common/message.js";

export default {
  components: {
    ConfirmButton,
    Loading,
  },
  props: {
    serviceName: {
      type: String,
      required: true,
    },
    soParam01: {
      type: String,
      required: true,
    },
    soParam02: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      serviceTitle: "",
      serviceExplanation: "",
      errors: {},
      hasMultiAddress: false,
      allAddresses: [],
      isLoading: false,
      gaType: "gaEvent",
      gaAction: "gaSoEvent",
      screenName: "input",
      startTime: null, // 画面表示開始時刻
      reasonOptions: [
        {
          label: "当社の公式サイト",
          value: "8f02fd17-d590-b9ba-b015-5d3a59309118",
          other: false,
        },
        {
          label: "イベント・セミナー",
          value: "350e6389-5d96-caae-680d-8838ea962d00",
          other: false,
        },
        {
          label: "キャンペーン・お知らせ",
          value: "2402edda-8139-ab38-a789-05f75d3fefe3",
          other: false,
        },
        {
          label: "広告",
          value: "feb6fa32-43f8-0841-ee9c-e28814cfaa19",
          other: false,
        },
        {
          label: "口コミ",
          value: "00c07422-929e-d7c1-d453-4a702bb31b45",
          other: false,
        },
        {
          label: "自然災害など必要性を感じて",
          value: "c26bbfbf-4454-d18b-2045-2350cc972a59",
          other: false,
        },
        {
          label: "その他",
          value: "c4977b87-67c1-fc3d-7c5f-50b62d9f405b",
          other: true,
        },
      ],
      serviceSettingItems: {},
      termsAgreeUrl: [],
      placeholderNewline: "%%n%%",
      token: "",
    };
  },
  computed: {
    ...mapState(["formData"]),
    ...mapState(["settingData"]),
    ...mapState(["serviceTitle"]),
    ...mapState(["serviceExplanation"]),
    ...mapState(["serviceSettingItems"]),
    ...mapState(["token"]),
  },
  async mounted() {
    document.title = "dアカウントログインした場合の画面";
    if (!this.serviceName) {
      this.showErrorPage();
    }
    this.formData.serviceName = this.serviceName;
    if (!this.settingData.isAuthenticated) {
      this.isLoading = true;
      await this.fetchData();
    } else {
      // 確認画面から戻ってきたとき設定情報をセット
      this.serviceSettingItems = this.$store.state.serviceSettingItems;

      // リンクURLセット
      this.setTermsAgreeUrl();
    }
    if (this.formData.companyAddressPostalCode) {
      // 郵便番号検索して住所をプルダウン選択肢としてセットする
      await this.fetchAddress();
    }

    this.serviceTitle = this.$store.state.serviceTitle;
    this.serviceExplanation = this.$store.state.serviceExplanation || "";
    this.token = this.$store.state.token;

    // GAイベント処理
    this.startTime = new Date(); // 画面表示開始時刻を記録
    this.sendGaEvent("display", "0");
  },
  methods: {
    ...mapMutations(["updateFormData"]),
    async fetchData() {
      try {
        const data = await this.getAccountData();
        this.updateFormData(data);
      } catch (error) {
        this.showErrorPage();
      } finally {
        this.isLoading = false;
      }
    },
    async getAccountData() {
      const accountData = {
        name: "",
        nameKana: "",
        docomoID: "",
        accountID: "",
        email: "",
        employeeCode: "",
        companyName: "",
        companyCode: "",
        companyNumber: "",
        phoneNumber: "",
        companyAddressPostalCode: "",
        companyAddress1: "",
        companyAddress2: "",
        managementGroup: "",
        departmentName: "",
        industry: "",
        addressCode: "",
        corpOccupation: "",
        corpPosition: "",
        maskDocomoID: "",
        corpCompanyUse: "",
        corpMemberType: "",
        corpPointUserImpossible: "",
      };
      try {
        const response = await axios.post(
          `${process.env.VUE_APP_API_BASE_URL}/soInputCheck`,
          {
            soParam01: this.soParam01,
            soParam02: this.soParam02,
            serviceName: this.serviceName,
            type: "validateKey",
          },
        );
        if (
          response.status === 200 &&
          response.data.status === "success" &&
          response.data.userData
        ) {
          const userData = response.data.userData;
          const soServiceSettingData = response.data.soServiceSetting;

          accountData.accountID = userData.accountID; // アカウント識別子（accoutID）は、サービス設定に関わらず無条件で保存

          // 公開状態チェック
          if (!soServiceSettingData.isOpen) {
            this.showErrorPage();
          }

          // サービス設定情報をセット
          this.serviceTitle = soServiceSettingData.pageTitle;
          this.serviceExplanation = this.sanitizeAndFormatText(
            soServiceSettingData.pageExplanation,
          );
          this.serviceSettingItems = cloneDeep(
            soServiceSettingData.serviceAllItems,
          );

          // 入力項目の情報をセット
          Object.keys(this.serviceSettingItems).forEach((key) => {
            this.serviceSettingItems[key].note = this.sanitizeAndFormatText(
              this.serviceSettingItems[key].note,
              false,
            );

            // 表示される項目の場合のみ、フォームにデフォルト値をセット
            if (
              typeof this.serviceSettingItems[key].userData !== "undefined" &&
              this.serviceSettingItems[key].displayFlag
            ) {
              accountData[key] =
                key === "companyAddress2"
                  ? this.concatenateAddresses(
                      userData.postSubAddress1,
                      userData.postSubAddress2,
                      userData.postSubAddress3,
                      userData.postSubAddress4,
                      userData.postSubAddress5,
                    )
                  : (userData[this.serviceSettingItems[key]?.userData] ?? "");
            }

            // 独自項目の情報をセット
            if (this.serviceSettingItems[key].itemType === "independentItems") {
              if (this.serviceSettingItems[key].inputType === "agree") {
                if (this.serviceSettingItems[key].text) {
                  this.serviceSettingItems[key].parsedLinks = this.parsedText(
                    this.serviceSettingItems[key].text,
                  );
                  this.serviceSettingItems[key].linkClickStates =
                    this.serviceSettingItems[key].parsedLinks
                      .filter((link) => link.type === "link")
                      .map(() => false);
                  this.serviceSettingItems[key].allLinksClicked = false;
                }

                if (this.serviceSettingItems[key].note) {
                  this.serviceSettingItems[key].parsedNote = this.parsedText(
                    this.serviceSettingItems[key].note,
                  );
                }
                this.formData[key] = false;
              } else {
                this.formData[key] = "";
              }
            }

            // 同意項目の情報をセット
            if (this.serviceSettingItems[key].itemType === "agreeItems") {
              // URL確認する必要のない項目だったら最初からチェックボックスを有効にしておく
              if (!this.serviceSettingItems[key].urlRequired) {
                this.settingData[key] = true;
              }

              // リンクURLセット
              this.termsAgreeUrl[key] = this.serviceSettingItems[key].url;
            }
          });

          // 業種、職種、企業利用登録フラグ、代表フラグ、ポイント/ユーザ管理許可設定の値をセット
          Object.entries(COMMON_ITEM_LOADING_MAP).forEach(
            ([key, { dataKey, method }]) => {
              // 項目設定が表示対象の場合のみ、データ設定を読み込み、accountData に保存する
              if (this.serviceSettingItems[key].displayFlag) {
                this[method](key, dataKey, response);
                accountData[key] = this.formData[key];
              }
            },
          );

          this.settingData.isAuthenticated = true;
          this.$store.state.serviceTitle = this.serviceTitle;
          this.$store.state.serviceExplanation = this.serviceExplanation;
          this.$store.state.serviceSettingItems = this.serviceSettingItems;

          // storeにトークンを保存
          this.token = response.data.token;
          this.$store.state.token = this.token;
        } else {
          this.showErrorPage();
        }
      } catch (error) {
        this.showErrorPage();
      }
      return accountData;
    },
    getNoteClass(item, hasError) {
      // 「同意事項」に該当する場合は、クラス名（"note-agree" または　"note-agree-error"）を返す
      if (item.inputType === "agree" || item.itemType === "agreeItems") {
        return `note-agree${hasError ? "-error" : ""}`;
      }

      // その他の inputType に応じて、クラス名（"note-text"、"note-text-error"など）を返す
      return `note-${item.inputType}${hasError ? "-error" : ""}`;
    },
    handleIndependentLinkClick(item, linkIndexInParsedLinks) {
      const links = item.parsedLinks.filter((link) => link.type === "link");

      const actualLinkIndex = links.findIndex(
        (link) => link === item.parsedLinks[linkIndexInParsedLinks],
      );

      if (actualLinkIndex !== -1) {
        item.linkClickStates[actualLinkIndex] = true;
        item.allLinksClicked = item.linkClickStates.every((clicked) => clicked);
      }
    },
    loadSelectData(commonKey, userDataKey, response) {
      const documentName = COMMON_SETTING_MAP[commonKey];
      if (!documentName) return;

      const settings = response.data.settings;
      const settingItem = settings.find(
        (setting) => setting.id === documentName,
      );

      if (settingItem) {
        const options = settingItem.setting.values;
        this.$store.commit("setSelectOptions", { key: commonKey, options });

        let defaultOption = options.find(
          (option) => option.key === response.data.userData[userDataKey],
        );
        if (!defaultOption) {
          defaultOption = options[0];
        }

        this.$store.commit("setSelectedKey", {
          key: commonKey,
          selectedKey: defaultOption.key,
        });
        this.updateSelectJson(commonKey);
      }
    },
    loadRadioData(commonKey, userDataKey, response) {
      const documentName = COMMON_SETTING_MAP[commonKey];
      if (!documentName) return;

      const settings = response.data.settings;
      const settingItem = settings.find(
        (setting) => setting.id === documentName,
      );

      if (settingItem) {
        const options = settingItem.setting.values.reduce((acc, item) => {
          acc[item.key] = item.label;
          return acc;
        }, {});
        this.$store.commit("setRadioOptions", { key: commonKey, options });

        let defaultOption = Object.keys(options).find(
          (key) => key === response.data.userData[userDataKey],
        );
        if (!defaultOption) {
          defaultOption = Object.keys(options)[0];
        }

        this.$store.commit("setSelectedRadio", {
          key: commonKey,
          selectedKey: defaultOption,
        });
        this.updateRadioJson(commonKey);
      }
    },
    updateSelectJson(settingKey) {
      const selectedKey =
        this.$store.state.settingData.selectedKeys[settingKey];
      const selectedLabel =
        this.$store.state.settingData.options[settingKey].find(
          (option) => option.key === selectedKey,
        )?.label || "";
      this.$store.commit("updateFormData", {
        [settingKey]: JSON.stringify({ [selectedKey]: selectedLabel }),
      });
    },
    updateRadioJson(settingKey) {
      const selectedKey =
        this.$store.state.settingData.selectedKeys[settingKey];
      const selectedLabel =
        this.$store.state.settingData.options[settingKey][selectedKey];
      this.$store.commit("updateFormData", {
        [settingKey]: JSON.stringify({ [selectedKey]: selectedLabel }),
      });
    },
    validateData() {
      this.errors = {};
      let errorFlg = true;

      // 入力項目のバリデーションをチェック
      Object.entries(this.serviceSettingItems).forEach(([key, item]) => {
        // 流通項目
        if (
          item.displayFlag &&
          !item.cmsOnlyFlag &&
          item.itemType === "commonItems"
        ) {
          const error = checkCommonItemValid(item, this.formData[key], key);
          if (error !== "") {
            this.errors[key] = error;
            errorFlg = false;
          }
          // 独自項目
        } else if (
          item.displayFlag &&
          !item.cmsOnlyFlag &&
          !item.deleteFlag &&
          item.itemType === "independentItems"
        ) {
          const error = checkIndependentItemValid(
            item,
            this.formData[key],
            key,
            this.formData,
          );
          if (error !== "") {
            this.errors[key] = error;
            errorFlg = false;
          }
          // 同意項目
        } else if (
          item.displayFlag &&
          !item.cmsOnlyFlag &&
          item.required &&
          item.itemType === "agreeItems"
        ) {
          const error = checkValidAgree(this.formData[key]);
          if (error !== "") {
            this.errors[key] = error;
            errorFlg = false;
          }
        }
      });

      return errorFlg;
    },
    // GAへのイベント送信処理
    sendGaEvent(action, time) {
      try {
        if (!window.ReactNativeWebView) {
          return;
        }
        window.ReactNativeWebView.postMessage(
          JSON.stringify({
            type: this.gaType,
            content: {
              action: this.gaAction,
              args: [
                {
                  service_name: this.serviceName,
                  screen_name: this.screenName,
                  action: action,
                  time: time,
                },
              ],
            },
          }),
        );
      } catch (e) {
        //alert(e); イベント送信がエラーでも申込は続けられるようにする
      }
    },
    async confirmInput() {
      if (this.validateData()) {
        try {
          this.isLoading = true;

          // サービス設定情報を取得
          const response = await this.fetchServiceData(
            "checkInput",
            this.formData,
          );
          if (response.status === 200 && response.data.status === "success") {
            // 画面表示開始時刻から現在時刻までの秒数を計算
            const endTime = new Date();
            const displayTime = Math.floor(
              (endTime.getTime() - this.startTime.getTime()) / 1000,
            );
            this.sendGaEvent("submit", displayTime.toString());
            this.$router.push("/confirmation");
          } else if (
            response.status === 200 &&
            response.data.status !== "success"
          ) {
            this.errors = response.data.errMsg;
          } else {
            this.showErrorPage();
          }
        } catch (error) {
          // ネットワーク未接続 または 通信エラーの場合
          if (!navigator.onLine || error.message === "Network Error") {
            const message = NETWORK_ERROR_MESSAGE;
            const toastId = "network-error";
            const position = "bottom-center";
            const timeout = 3000;

            // ネットワークエラー用のトーストを表示
            showInfoToast(message, toastId, position, timeout);
          } else {
            this.showErrorPage();
          }
        } finally {
          this.isLoading = false;
        }
      } else {
        this.focusFirstErrorInput();
      }
    },
    async fetchServiceData(type, formData) {
      return await axios.post(
        `${process.env.VUE_APP_API_BASE_URL}/soInputCheck`,
        { data: formData, serviceName: formData.serviceName, type },
        {
          headers: {
            Authorization: `Bearer ${this.token}`,
          },
        },
      );
    },
    async fetchAddress() {
      this.allAddresses = [];
      this.errors.companyAddressPostalCode = "";
      this.hasMultiAddress = false;

      // 会社住所（郵便番号）の入力チェックをしてから郵便番号検索する
      const companyAddressPostalCodeItem =
        this.serviceSettingItems["companyAddressPostalCode"];

      // 項目が存在し、かつ itemType が "commonItems" の場合にバリデーションを実行
      if (
        companyAddressPostalCodeItem &&
        companyAddressPostalCodeItem.itemType === "commonItems"
      ) {
        const retCompanyAddressPostalCode = checkCommonItemValid(
          companyAddressPostalCodeItem,
          this.formData.companyAddressPostalCode,
        );

        // バリデーション結果がエラーの場合
        if (retCompanyAddressPostalCode !== "") {
          this.errors.companyAddressPostalCode = retCompanyAddressPostalCode;
          return;
        }
      }

      try {
        const response = await axios.get(
          `https://zipcloud.ibsnet.co.jp/api/search?zipcode=${this.formData.companyAddressPostalCode}`,
        );
        const data = response.data.results;
        if (data && data.length > 0) {
          this.allAddresses = data.map(
            (item) => item.address1 + item.address2 + item.address3,
          );
          if (data.length === 1) {
            this.formData.companyAddress1 = this.allAddresses[0];
          } else if (data.length > 1) {
            this.hasMultiAddress = true;

            // 一致するデータを検索
            const matchAddress = this.allAddresses.some(
              (item) => item === this.formData.companyAddress1,
            );

            // プルダウン項目に値がないときは都道府県市町村を初期化
            if (!matchAddress) {
              this.formData.companyAddress1 = "";
            }
          }
        } else {
          this.formData.companyAddress1 = "";
          this.errors.companyAddressPostalCode = "データが見つかりません。";
        }
      } catch (error) {
        // eslint-disable-next-line
        alert("Failed to fetch address");
      }
    },
    // 添付ファイル設定処理
    handleFileUpload(event, key) {
      const file = event.target.files[0];
      if (!file) {
        this.formData[key] = null; // データクリア
        return; // ファイルが選択されていない場合の処理
      }

      const reader = new FileReader();
      reader.onload = (e) => {
        const [, content] = e.target.result.split(","); // resultプロパティからバイナリを取得
        this.formData[key] = {
          name: file.name,
          size: file.size,
          type: file.type,
          binary: content,
        };
      };

      reader.readAsDataURL(file); // バイナリをData URLとして読み込む
    },
    // 添付ファイル名表示
    getFileNameToDisplay(value) {
      if (typeof value === "object" && value !== null && value.name) {
        return value.name;
      } else {
        return "ファイルが選択されていません";
      }
    },
    focusFirstErrorInput() {
      setTimeout(() => {
        const inputs = document.querySelectorAll(
          ".InputBox, .TextAreaBox, .dropdown, .radioGroup, .checkBoxGroup, .checkBox, .fileInput",
        );
        for (const input of inputs) {
          if (input.classList.contains("error")) {
            input.focus();
            input.scrollIntoView({
              behavior: "smooth",
              block: "center",
            });
            break;
          }
        }
      }, 500); // エラー表示のDOM更新を待ってからフォーカスする
    },
    showErrorPage() {
      this.$router.push("/error");
    },
    concatenateAddresses(...addresses) {
      return addresses.map((addr) => addr || "").join("");
    },
    handleLinkClick(serviceSettingItemsKey) {
      this.settingData[serviceSettingItemsKey] = true;
    },
    // 文字列形式の JSON をパースしてオブジェクトに変換
    parseValues(values) {
      try {
        const parseValues = JSON.parse(values);
        return JSON.parse(parseValues.values); // JSONをパース
      } catch (error) {
        return {}; // パース失敗時は空のオブジェクトを返す
      }
    },
    createCheckboxData(serviceSettingItemsKey, item) {
      // this.formDataのキーをソートして新しいオブジェクトを生成
      const sortedFormData = Object.keys(this.formData)
        .sort() // キーを昇順にソート
        .reduce((sortedObj, key) => {
          sortedObj[key] = this.formData[key]; // ソート順にプロパティを追加
          return sortedObj;
        }, {});

      const itemSetting = this.parseValues(item.setting);

      // 独自項目のチェックボックスデータを作成
      this.formData[serviceSettingItemsKey] = "{";
      for (const key in sortedFormData) {
        // チェックのついているものが対象
        if (
          key.includes(serviceSettingItemsKey + "_check_") &&
          this.formData[key]
        ) {
          const value = key.replace(serviceSettingItemsKey + "_check_", "");

          let itemSettingValue = "";
          if (typeof itemSetting[value] === "undefined") {
            itemSettingValue = value;
          } else {
            itemSettingValue = itemSetting[value];
          }

          this.formData[serviceSettingItemsKey] +=
            '"' + value + '":"' + itemSettingValue + '",';
        }
      }
      // チェックボックスが選択されている場合、JSON文字列形式に設定する。
      // 選択されていない場合は、空白に設定する。
      this.formData[serviceSettingItemsKey] = this.formData[
        serviceSettingItemsKey
      ].slice(0, -1)
        ? this.formData[serviceSettingItemsKey].slice(0, -1) + "}"
        : "";
    },
    // Markdown形式のテキスト内にあるリンク `[テキスト](URL)` を解析し、通常のテキストとリンクのオブジェクト配列に変換する。
    parsedText(markdownText) {
      // `[テキスト](URL)` の Markdown リンクを抽出（http/https の両方を対象）
      const regex = /\[([^\]]+)\]\((https?:\/\/[^\\)]+)\)/g;
      const parts = [];
      let lastIndex = 0;
      let match;

      // プレースホルダー（%%n%%）を \n に置換
      markdownText = this.sanitizeAndFormatText(markdownText, false);

      // 正規表現で一致する Markdown リンクをすべて処理
      while ((match = regex.exec(markdownText)) !== null) {
        // 通常テキスト部分を追加
        if (match.index > lastIndex) {
          parts.push({
            type: "text",
            text: markdownText.slice(lastIndex, match.index),
          });
        }

        // リンク部分を追加
        parts.push({ type: "link", text: match[1], url: match[2] });

        lastIndex = regex.lastIndex;
      }

      // 残りのテキストを追加
      if (lastIndex < markdownText.length) {
        parts.push({ type: "text", text: markdownText.slice(lastIndex) });
      }

      return parts;
    },
    // リンクURLセット
    setTermsAgreeUrl() {
      const keys = ["locationAgree", "termsAgree", "privacyPolicyAgree"];

      keys.forEach((key) => {
        const url = this.serviceSettingItems[key]?.url;
        if (url) {
          this.termsAgreeUrl[key] = url;
        }
      });
    },
    // 特定の文字を置き換える
    htmlDecode(beforeStr) {
      return beforeStr
        .replace(/%%amp%%/g, "&")
        .replace(/%%lt%%/g, "<")
        .replace(/%%gt%%/g, ">")
        .replace(/%%quot%%/g, '"')
        .replace(/%%#39%%/g, "'");
    },
    // プレースホルダー付きテキストを整形し、必要に応じてHTMLとしてサニタイズして返す
    sanitizeAndFormatText(text, toHtml = true) {
      let decoded = this.htmlDecode(text || "");

      // 「<p><br></p>」だけが入っていた場合は空文字とみなす（CMS側のリッチテキストエディタで未入力でもタグが入ってしまうため）
      if (decoded.trim() === "<p><br></p>") {
        decoded = "";
      }

      // プレースホルダー（例: %%n%%）を <br> もしくは \n に置換
      const replacedText = decoded.replace(
        new RegExp(this.placeholderNewline, "g"),
        toHtml ? "<br>" : "\n",
      );

      // HTML として使う場合は XSS 対策でサニタイズ、それ以外はそのまま返す
      return toHtml ? DOMPurify.sanitize(replacedText) : replacedText;
    },
  },
};
</script>

<style src="./dx-shukkinbo-input.css"></style>
